import { useMemo } from 'react'

import { SplitsDialogContent } from '~/components/component-library/Dialog'
import { PositionClaimDialog } from '~/components/smart-accounts/positions/PositionClaimDialog'
import { ClankerPositionDetailsContent } from '~/components/smart-accounts/positions/clanker'
import { PositionBalance } from '~/components/smart-accounts/positions/types'
import { UniswapPositionDetailsContent } from '~/components/smart-accounts/positions/uniswap'
import { getPositionTypeLabel } from '~/components/smart-accounts/positions/utils'
import { useAuth } from '~/context/AuthProvider'
import { displayCurrency } from '~/utils/display'

export const PositionDetailsDialog = ({
  balance,
}: {
  balance: PositionBalance
}) => {
  const { setGlobalModalState } = useAuth()

  const dialogContent = useMemo(() => {
    switch (balance.positionType) {
      case 'clanker':
        return <ClankerPositionDetailsContent balance={balance} />
      case 'uniswap-v3':
      case 'uniswap-v4':
        return <UniswapPositionDetailsContent balance={balance} />
      default:
        return <ClankerPositionDetailsContent balance={balance} />
    }
  }, [balance])

  return (
    <SplitsDialogContent
      id="positionDetails"
      variant="cta"
      title={`${getPositionTypeLabel(balance.positionType)} position`}
      actionButton={{
        text: `Claim ${!!balance.feesUsdValue ? displayCurrency(balance.feesUsdValue, { showLessThanForSmallValues: true }) : 'fees'}`,
        isDisabled: !balance.tokens.some((t) => t.claimableAmount > 0n),
        onClick: () => {
          setGlobalModalState({
            isOpen: true,
            content: (
              <PositionClaimDialog
                positionBalance={balance}
                setIsOpen={() => {
                  setGlobalModalState({
                    isOpen: false,
                    content: null,
                  })
                }}
              />
            ),
          })
        },
      }}
    >
      {dialogContent}
    </SplitsDialogContent>
  )
}
